import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import * as messageConstants from '../../../shared/messages';

import './WsFederationIdpMetadataPopup.scss';

class WsFederationIdpMetadataPopup extends Component {
    state = {
        copiedWsFedIssuerUrl: false,
        copiedWsFedPassiveUrl: false,
        copiedWsFedActiveUrl: false,
        copiedWsFedMetadataUrl: false,
        copiedWsFedLogoffUrl: false,
        downloadCertificate: false,
    }

    handleCopyText = (event) => {
        const textItem = event.currentTarget.id;
        const copied = {};

        copied[textItem] = true;
        this.setState(copied);
    }
    handleCopyTextClear = (event) => {
        const textItem = event.currentTarget.id;
        const copied = {};

        copied[textItem] = false;
        this.setState(copied);
    }
    handleDownloadCertificate = () => {

        const fileData = [this.props.idpMetadata.publicKeyPemCertificate];
        const fileName = "Imprivata IDP certificate.cer";
        if (window.navigator.msSaveOrOpenBlob) {
            let blobObject = new Blob(fileData);
            window.navigator.msSaveOrOpenBlob(blobObject, fileName);
        }
        else {
            let blob = new Blob(fileData, {type: 'text/plain;charset=utf-8;'});
            let $link = document.createElement("a");
            let url = URL.createObjectURL(blob);
            $link.setAttribute("target", "_blank");
            $link.setAttribute("href", url);
            $link.setAttribute("download", fileName);
            $link.style.visibility = "hidden";
            document.body.appendChild($link);
            $link.click();
            document.body.removeChild($link);
        }
    }
    handleHideModalWsFedIdpMetadata = () => {
        this.setState({
            copiedWsFedIssuerUrl: false,
            copiedWsFedPassiveUrl: false,
            copiedWsFedActiveUrl: false,
            copiedWsFedMetadataUrl: false,
            copiedWsFedLogoffUrl: false,
            downloadCertificate: false,
        });
        this.props.handleHideModalWsFedIdpMetadata();
    }

    componentDidUpdate() {
        if (this.props.errorMsg) {
            this.props.handleHideModalWsFedIdpMetadata();
        }
    }

    render() {
        const {
            idpMetadata
        } = this.props;

        return (
            <div className="ws-fed-idp-metadata-container">
                <Modal
                    id="idpMetadataModal"
                    show={this.props.showModalWsFedIdpMetadata}
                    onHide={this.handleHideModalWsFedIdpMetadata}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    dialogClassName="idp-metadata-modal">

                    <Modal.Header className="basic-modal-header">
                        <Modal.Title>
                            <span className="basic-modal-header-title">{messageConstants.WS_FED_IDP_METADATA}</span>
                            <button className="entity-id-modal-close" type="button"
                                    onClick={this.handleHideModalWsFedIdpMetadata}/>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="idp-metadata-modal-body">
                        <div className="import-modal-body-top">
                            {messageConstants.IDP_WS_FED_METADATA_SUBTITLE}
                        </div>
                        <dl className="manual-idp-list">
                            <dt className="entry-label">
                                {messageConstants.WS_FED_ISSUER_URL}
                            </dt>
                            <dd>
                                <div className="copy-row">
                                    <div className="entry-value"
                                         id="wsFedIssuerUrlValue">
                                        {idpMetadata.wsFedIssuerUrl}
                                    </div>
                                    <div className="copy-link">
                                        <CopyToClipboard text={idpMetadata.wsFedIssuerUrl}>
                                            {
                                                this.state.copiedWsFedIssuerUrl ? (
                                                    <input id="copiedWsFedIssuerUrl"
                                                           onClick={this.handleCopyTextClear}
                                                           type="button"
                                                           value={messageConstants.COPIED}
                                                           className="button_check"/>
                                                ) : (
                                                    <button
                                                        title={messageConstants.COPY}
                                                        id="copiedWsFedIssuerUrl"
                                                        className="btn btn-link"
                                                        onClick={this.handleCopyText}
                                                    >
                                                        <i className="copy-mark"/>
                                                    </button>
                                                )
                                            }
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </dd>

                            <dt className="entry-label">
                                {messageConstants.WS_FED_PASSIVE_URL}
                            </dt>
                            <dd>
                                <div className="copy-row">
                                    <div className="entry-value"
                                         id="wsFedPassiveUrlValue">
                                        {idpMetadata.wsFedPassiveUrl}
                                    </div>
                                    <div className="copy-link">
                                        <CopyToClipboard text={idpMetadata.wsFedPassiveUrl}>
                                            {
                                                this.state.copiedWsFedPassiveUrl ? (

                                                    <input id="copiedWsFedPassiveUrl"
                                                           onClick={this.handleCopyTextClear}
                                                           type="button"
                                                           value={messageConstants.COPIED}
                                                           className="button_check"/>
                                                ) : (
                                                    <button
                                                        title={messageConstants.COPY}
                                                        id="copiedWsFedPassiveUrl"
                                                        className="btn btn-link"
                                                        onClick={this.handleCopyText}
                                                    >
                                                        <i className="copy-mark"/>
                                                    </button>
                                                )
                                            }
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </dd>

                            <dt className="entry-label">
                                {messageConstants.WS_FED_ACTIVE_URL}
                            </dt>
                            <dd>
                                <div className="copy-row">
                                    <div className="entry-value"
                                         id="wsFedActiveUrlValue">
                                        {idpMetadata.wsFedActiveUrl}
                                    </div>
                                    <div className="copy-link">
                                        <CopyToClipboard text={idpMetadata.wsFedActiveUrl}>
                                            {
                                                this.state.copiedWsFedActiveUrl ? (

                                                    <input id="copiedWsFedActiveUrl"
                                                           onClick={this.handleCopyTextClear}
                                                           type="button"
                                                           value={messageConstants.COPIED}
                                                           className="button_check"/>

                                                ) : (
                                                    <button
                                                        title={messageConstants.COPY}
                                                        id="copiedWsFedActiveUrl"
                                                        className="btn btn-link"
                                                        onClick={this.handleCopyText}
                                                    >
                                                        <i className="copy-mark"/>
                                                    </button>
                                                )
                                            }
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </dd>

                            <dt className="entry-label">
                                {messageConstants.WS_FED_METADATA_URL}
                            </dt>
                            <dd>
                                <div className="copy-row">
                                    <div className="entry-value"
                                         id="wsFedMetadataUrlValue">
                                        {idpMetadata.wsFedMetadataUrl}
                                    </div>
                                    <div className="copy-link">
                                        <CopyToClipboard text={idpMetadata.wsFedMetadataUrl}>
                                            {
                                                this.state.copiedWsFedMetadataUrl ? (

                                                    <input id="copiedWsFedMetadataUrl"
                                                           onClick={this.handleCopyTextClear}
                                                           type="button"
                                                           value={messageConstants.COPIED}
                                                           className="button_check"/>
                                                ) : (
                                                    <button
                                                        title={messageConstants.COPY}
                                                        id="copiedWsFedMetadataUrl"
                                                        className="btn btn-link"
                                                        onClick={this.handleCopyText}
                                                    >
                                                        <i className="copy-mark"/>
                                                    </button>
                                                )
                                            }
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </dd>

                            {idpMetadata.wsFedLogoffUrl ? (
                                <div>
                                    <dt className="entry-label">
                                        {messageConstants.WS_FED_LOGOFF_URL}
                                    </dt>
                                    <dd>
                                        <div className="copy-row">
                                            <div className="entry-value"
                                                 id="wsFedLogoffUrlValue">
                                                {idpMetadata.wsFedLogoffUrl}
                                            </div>
                                            <div className="copy-link">
                                                <CopyToClipboard text={idpMetadata.wsFedLogoffUrl}>
                                                    {
                                                        this.state.copiedWsFedLogoffUrl ? (

                                                            <input id="copiedWsFedLogoffUrl"
                                                                   onClick={this.handleCopyTextClear}
                                                                   type="button"
                                                                   value={messageConstants.COPIED}
                                                                   className="button_check"/>
                                                        ) : (
                                                            <button
                                                                title={messageConstants.COPY}
                                                                id="copiedWsFedLogoffUrl"
                                                                className="btn btn-link"
                                                                onClick={this.handleCopyText}
                                                            >
                                                                <i className="copy-mark"/>
                                                            </button>
                                                        )
                                                    }
                                                </CopyToClipboard>
                                            </div>
                                        </div>
                                    </dd>
                                </div>
                            ) : null}

                            <dd className="copy-row idp-metadata-xml">
                                <div className="entry-value">
                                    {messageConstants.IDP_METHOD_CERTIFICATE}
                                </div>
                                <div className="copy-link">
                                    <button
                                        title={messageConstants.DOWNLOAD}
                                        id="downloadIdpCertificateButton"
                                        className="btn btn-link"
                                        onClick={this.handleDownloadCertificate}
                                    >
                                        <i className="download-mark"/>
                                    </button>
                                </div>
                            </dd>
                        </dl>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default WsFederationIdpMetadataPopup;
